(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["form-inquiry"] && !Shopify.designMode) return;
  try {
    const btn = document.querySelector("#inquiry-btn");

  if (!btn) return;

  btn.addEventListener("click", () => {
    const formWrapper = document.getElementById("AY3ZkbEt1bTBDZFc2e__forms_inline_XqimaD");
    if (!formWrapper) return;

    const form = formWrapper.querySelector("#app-embed");
    if (!form) return;

    formWrapper.style.display = "block";
    btn.style.display = "none";

    // Poll for shadowRoot and fill the form when ready
    const maxWait = 10000;
    const intervalTime = 100;
    let waited = 0;

    const interval = setInterval(() => {
      const formShadow = form.shadowRoot;
      if (formShadow) {
        // const section = formShadow.querySelector('section[data-sizing="form-wrapper"]');
        // section.style.maxWidth = '100%';

        const product_url = formShadow.querySelector('[id="custom#product_url"]');
        const product_title = formShadow.querySelector('[id="custom#product_title"]');
        const fNameInput = formShadow.querySelector('[id="first_name"]');
        const emailInput = formShadow.querySelector('[id="email"]');
        const phoneInput = formShadow.querySelector('[id="phone_number"]');

        if (product_url && fNameInput && emailInput && phoneInput) {
          product_url.value = formWrapper.getAttribute("data-form-url") || "";
          product_title.value = formWrapper.getAttribute("data-form-title") || "";
          fNameInput.value = formWrapper.getAttribute("data-form-fName") || "";
          emailInput.value = formWrapper.getAttribute("data-form-email") || "";
          phoneInput.value = formWrapper.getAttribute("data-form-phone") || "";

          [product_title, product_url, fNameInput, emailInput, phoneInput].forEach(input => {
            input.dispatchEvent(new Event("input", { bubbles: true }));
          });

          // Hide SKU input field
          product_url.closest("div")?.style.setProperty("display", "none");
          product_title.closest("div")?.style.setProperty("display", "none");

          clearInterval(interval);
        }
      }

      waited += intervalTime;
      if (waited >= maxWait) {
        console.warn("Timeout: Shadow root or inputs not found.");
        clearInterval(interval);
      }
    }, intervalTime);
  });
  } catch(e) { console.error(e); }
})();

})();
